/**
 * arraySet sets an item in an immutable array and returns a new array
 */
export default function arraySet<T>(arr: readonly T[], i: number, value: T): T[] {
  const arrCopy = arr.slice();
  arrCopy[i] = value;
  return arrCopy;
}
